<script lang="ts">
    import { imageQuote, unsetImageQuoteWords } from "@utils/image-editor/image-quote"
    import ImageQuoteWrapper from "./ImageQuoteWrapper.svelte"
</script>

{#if $imageQuote}
    <ImageQuoteWrapper imageQuote={$imageQuote} onExit={() => unsetImageQuoteWords()} />
{/if}
